import urlJoin from 'url-join';

export const errorRedirect = (error, description) => {
  const baseUrl = window.env.baseUrl;
  const uri = urlJoin(baseUrl, '/error')
    + '?error=' + encodeURI(error)
    + '&error_description=' + encodeURI(description);
  window.location.replace(uri);
};

export const homeRedirect = () => {
  const baseUrl = window.env.baseUrl;
  window.location.replace(baseUrl);
};